/* eslint-disable @next/next/no-img-element */
import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { gsColors } from '../../../../styles/Variables'

const CheckboxDiv = styled.div`
  cursor: pointer;

  input[type='checkbox'] {
    display: none;
  }

  label {
    color: $revolver;
    display: block;
    font-size: 12px;
    line-height: 20px;
    padding-left: 30px;
    position: relative;

    a {
      color: ${gsColors.seance};
    }
  }

  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    border-radius: 50%;
    box-sizing: border-box;
    transition: all 250ms;
    cursor: pointer;

    img {
      position: relative !important;
      width: 24px !important;
      height: 24px !important;
    }
  }
`

const CheckboxSingle = ({
  name,
  onChange,
  textComponent: TextComponent,
  value,
  whiteUnchecked = false,
  cobaltChecked = false
}) => {
  const boxStyle = value
    ? {
      backgroundColor: cobaltChecked ? gsColors.cobalt : gsColors.sunsetOrange,
      border: 'none'
    }
    : {
      backgroundColor: whiteUnchecked ? gsColors.white : '#F3F0F0',
      border: `1px solid ${gsColors.lightTangerine}`
    }

  return (
    <CheckboxDiv>
      <input
        type="checkbox"
        name={name}
        id={name}
        onChange={onChange}
        value={value}
        checked={value}
      />
      <label htmlFor={name} aria-label={name}>
        <div
          aria-label={name + '-checkbox'}
          onKeyPress={e => (e.key === 'Enter' ? onChange(e) : false)}
          role="checkbox"
          aria-checked={value}
          tabIndex={0}
          className="box"
          style={boxStyle}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          {value && <img src={cobaltChecked ? '/images/checkmark_cobalt_white.svg' : '/images/checkmark_white.svg'} alt='' aria-hidden='true' />}
        </div>
        <TextComponent />
      </label>
    </CheckboxDiv>
  )
}

CheckboxSingle.propTypes = {
  name: PropTypes.string.isRequired,
  textComponent: PropTypes.func.isRequired
}

export default CheckboxSingle
